import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';
import { capitalizeFirstLetter } from '../../../../utils/textFormatUtils';

const Indications = forwardRef(function ({ indications }, ref) {
  return (
    <div ref={ref} className="mb-36 scroll-offset" id="indications-section">
      <h4>Indications</h4>
      <div>
        <div className="accordion-body">
          {indications?.length ? (
            <ul className="indicator">
              {indications.map((indication, key) => (
                <li className="f-16 font-semibold" key={`indication-${key}`}>
                  {capitalizeFirstLetter(indication.ConditionDesc)}
                </li>
              ))}
            </ul>
          ) : (
            <InfoUnavailable />
          )}
        </div>
      </div>
    </div>
  );
});

Indications.propTypes = {
  indications: PropTypes.array.isRequired,
};

Indications.displayName = 'Indications';

export default Indications;
